import { AppRouteProps } from "@bsm/component";
import { InvoiceGroupViewerContainer } from "./container/InvoiceGroupViewerContainer";
import { UserStudentFamilyRoutes } from "./views/family/UserStudentFamilyRoutes";
import { ScholarityListRoutes } from "./views/scholarity/ScholarityListRoutes";
import { BankListRoutes } from "./views/bank/BankListRoutes";

export const StudentGroupViewerRoutes: Array<AppRouteProps> = [
    {
        path: 'viewer',
        element: <InvoiceGroupViewerContainer />,
        children: [
            ...UserStudentFamilyRoutes,
            ...ScholarityListRoutes,
            ...BankListRoutes
        ]
    }
]